import {
  Box,
  Divider,
  Flex,
  Button,
  Icon,
  Heading,
  Spinner,
  useToast,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { RiAddLine } from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import ReactTableComponent from '../../components/TableComponent';
import api from '../../service/api';
import { getColumn } from '../../utils/getClientColumn';
import { useHistory } from 'react-router-dom';
import { SiderbarResponsive } from '../../components/SiderbarResponsive';
import { Wapper } from '../../components/Wapper';
import { useAuth } from '../../context/AuthContext';
import { ExcludeDialog } from '../../components/ExlcudeDialog';
import { ehLogistica } from '../../helpers/perfilLogistica';
import { useFiliaisPermitidas } from '../../hooks/useFiliaisPermitidas';

export default function ListClient() {
  const [clients, setClients] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [idToDelete, setIdToDelete] = useState('');

  const { user } = useAuth();
  const { ids: filiaisPermitidasIds, carregando: carregandoFiliais } = useFiliaisPermitidas();
  const toast = useToast();

  const history = useHistory();

  const userFind = user.empresa.id;

  const { isOpen, onOpen, onClose } = useDisclosure();

  function handleDelete(id: any) {
    setIdToDelete(id);
    onOpen();
  }

  const x = async (e: any, id: string) => {
    try {
      await api.patch(`/api-essencial/v1/clientes/update-excluido/${id}`, {
        excluido: true,
      });

      const response = await api.get(
        `/api-essencial/v1/clientes/${user.empresa.id}/empresa?excluido=false`
      );

      setClients(response.data.data);

      toast({
        title: 'Categoria deletada com sucesso',
        description: ``,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      history.push('/listar/cliente');
    } catch (error) {
      if (clients.length === 1) {
        toast({
          title: 'Categoria deletada com sucesso',
          description: ``,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setClients([]);
      }
    }
  };

  const column = getColumn(handleDelete, '/edit/cliente', !ehLogistica(user));

  useEffect(() => {
    if (carregandoFiliais) return;

    const requisicao = api
      .get(`/api-essencial/v1/clientes`)
      .then((response) => response.data);

    requisicao
      .then((dados) => {
        const vistos = new Set<string>();
        const permitidas = filiaisPermitidasIds
          ? new Set(filiaisPermitidasIds)
          : null;
        setClients((Array.isArray(dados) ? dados : []).filter((cliente: any) => {
          if (permitidas && !permitidas.has(cliente?.empresa_id)) return false;
          const id = cliente?.cliente_id || cliente?.id;
          if (!id || vistos.has(id)) return false;
          vistos.add(id);
          return true;
        }));
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, [userFind, carregandoFiliais, filiaisPermitidasIds]);

  return (
    <>
      <Header />
      <SiderbarResponsive />

      <Flex align="start" mx="auto" mt="8" px="6">
        <Wapper>
          <Box flex="1" p="8" bg="gray.800" borderRadius={8} mb="16">
            <Flex justify="space-between" align="center">
              <Heading size="md" fontWeight="normal">
                LISTA DE CLIENTES
              </Heading>
              {/* <Button
                as="a"
                size="sm"
                fontSize="sm"
                colorScheme="orange"
                leftIcon={<Icon as={RiAddLine} />}
                cursor="pointer"
                onClick={() => history.push("/cadastro/cliente")}
              >
                Cadastrar
              </Button> */}
            </Flex>

            <Divider my="6" borderColor="gray.700" />

            <Flex justifyContent="center">
              {isLoading ? (
                <Spinner color="white" />
              ) : (
                <>
                  {clients.length === 0 ? (
                    <Flex>
                      <Text color="orange.200">Sem clientes para exibir</Text>
                    </Flex>
                  ) : (
                    <ReactTableComponent
                      columns={column}
                      data={clients}
                      isPagenable
                    />
                  )}
                </>
              )}
            </Flex>
          </Box>
        </Wapper>
      </Flex>
      <ExcludeDialog
        isOpen={isOpen}
        onClose={onClose}
        label="cliente"
        deleteFunction={(e) => {
          x(e, idToDelete);
          onClose();
        }}
      />
    </>
  );
}
